import React, { useEffect, useState, useLayoutEffect } from "react";
import PageTitle from "../banner";
import { Container, Row, Col, Card } from "react-bootstrap";

function Policy() {
  const getInitialBgImage = () =>
    window.innerWidth <= 768
      ? "img/about/policymb.jpg"
      : "img/about/banner04.jpg";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [bgImage, setBgImage] = useState(getInitialBgImage);

  useLayoutEffect(() => {
    const handleResize = () => {
      setBgImage(
        window.innerWidth <= 768
          ? "img/about/policymb.jpg"
          : "img/about/banner04.jpg"
      );
      setIsMobile(window.innerWidth <= 768);
    };

    const debounceResize = debounce(handleResize, 100);

    window.addEventListener("resize", debounceResize);
    return () => {
      window.removeEventListener("resize", debounceResize);
    };
  }, []);

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  return (
    <div>
      {/* Page Banner */}
      <div style={{ marginTop: "20px" }}>
        <PageTitle desc="Policy" img={bgImage} />
      </div>

      {/* Policy Section */}
      <section style={{ padding: "40px 0", backgroundColor: "#f8f9fa" }}>
        <Container>
          <Row>
            <Col>
              <Card className="shadow-sm border-0">
                <Card.Body style={{ padding: "1.5rem" }}>
                  <div style={{ marginBottom: "20px" }}>
                    <h5
                      style={{
                        color: "#343a40",
                        textAlign: "center",
                        marginBottom: "20px",
                        fontWeight: 600,
                      }}
                    >
                      Photography Usage Policy for Nagesh Murthy Photography
                    </h5>
                    <p style={{ textAlign: "center" }}>
                      <b style={{ color: "#343a40" }}>Effective Date : </b>{" "}
                      23-11-2024
                    </p>

                    {/* Introduction */}
                    <p
                      style={{
                        color: "#6c757d",
                        textAlign: "justify",
                        marginTop: "20px",
                        fontSize: "14px",
                      }}
                    >
                      This Photography Usage Policy ("Policy") governs the use,
                      distribution, and reproduction of all photographs, images,
                      and other visual content ("Content") displayed on the
                      website <strong>https://nageshamurthyclicks.com</strong>{" "}
                      ("Website") , owned and operated by Nagesh Murthy under
                      the brand name <strong>Nagesh Murthy Clicks</strong>. By
                      accessing, viewing, or downloading Content from this
                      Website, you acknowledge that you have read, understood,
                      and agree to the terms and conditions set forth in this
                      Policy.
                    </p>

                    {/* Policy Sections */}
                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        1. Ownership and Copyright of Content
                      </h6>
                      <ul style={{ paddingLeft: "20px" }}>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Copyright Notice
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            All photographs, images, and other visual content
                            displayed on this Website are the sole © copyright
                            property of <strong> Nagesh Murthy</strong>,
                            operating under the brand name{" "}
                            <strong>Nagesh Murthy Clicks</strong> and are
                            protected by national and international copyright
                            laws.
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            All images and photographs on this Website are
                            marked with the appropriate copyright symbol (©) and
                            the ownership details of{" "}
                            <strong>
                              Nagesh Murthy / Nagesh Murthy Clicks
                            </strong>
                          </p>
                        </li>

                        <li style={{ marginBottom: "15px" }}>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Proprietary Rights
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            <strong>Nagesh Murthy</strong> retains all
                            proprietary and intellectual property rights over
                            the Content, including the rights to use, reproduce,
                            modify, and license the Content.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        2. Restrictions on Use of Content
                      </h6>
                      <ul style={{ paddingLeft: "20px" }}>
                        <p
                          style={{
                            color: "#6c757d",
                            textAlign: "justify",
                            fontSize: "14px",
                          }}
                        >
                          By accessing and viewing the Content on this Website,
                          you agree to the following restrictions
                        </p>

                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            No Reproduction
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            You may not copy, reproduce, or duplicate any images
                            or Content from this Website, in whole or in part,
                            for any purpose, including personal, commercial, or
                            editorial use, without obtaining prior written
                            authorization from <strong>Nagesh Murthy .</strong>
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            No Distribution or Sale
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            You may not distribute, sell, license, or otherwise
                            make any Content available to third parties for any
                            purpose, including commercial use or promotion.
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            No Alterations
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            You may not modify, crop, filter, or alter any
                            images in any way, including resizing, editing, or
                            applying any kind of digital manipulation.
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            No Unauthorized Online Use
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            You may not use the Content on social media, blogs,
                            websites, or other online or offline media without
                            written consent from{" "}
                            <strong>Nagesh Murthy .</strong>
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            No Commercial Use
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            You may not use any Content for commercial purposes
                            without a licensing agreement.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        3. Requesting Permission for Use of Content
                      </h6>
                      <ul style={{ paddingLeft: "20px" }}>
                        <p
                          style={{
                            color: "#6c757d",
                            textAlign: "justify",
                            fontSize: "14px",
                          }}
                        >
                          If you wish to use any Content from this Website, you
                          must obtain prior written permission from{" "}
                          <strong>Nagesh Murthy .</strong>. To request
                          permission, please follow the steps below:
                        </p>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Submit a Request
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            Email your request to{" "}
                            <strong>rohinag2@gmail.com</strong> with the
                            following details:
                          </p>
                          <ul
                            style={{
                              paddingLeft: "20px",
                              listStyleType: "disc",
                              marginBottom: "1rem",
                            }}
                          >
                            <li>
                              {" "}
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Specific image(s) you wish to use.
                              </p>{" "}
                            </li>
                            <li>
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Intended use (e.g., personal, commercial,
                                editorial, marketing).
                              </p>
                            </li>
                            <li>
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                The medium where the image will appear (e.g.,
                                website, social media, print).
                              </p>
                            </li>
                            <li>
                              {" "}
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Duration and scope of the usage.
                              </p>
                            </li>
                            <li>
                              {" "}
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                {" "}
                                Any other relevant information.
                              </p>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Licence Agreement
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            If your request is approved, you will be provided
                            with a formal licence agreement, which may include:
                          </p>

                          <ul
                            style={{
                              paddingLeft: "20px",
                              listStyleType: "disc",
                              marginBottom: "1rem",
                            }}
                          >
                            <li>
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                Licensing fees, if applicable.
                              </p>
                            </li>
                            <li>
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                Terms of usage, including limitations on time,
                                geographical area, and scope.
                              </p>
                            </li>
                            <li>
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                Credit requirements for the photographer and the
                                brand name <strong>Nagesh Murthy .</strong>
                              </p>
                            </li>
                            <li>
                              {" "}
                              <p
                                style={{
                                  color: "#6c757d",
                                  textAlign: "justify",
                                  fontSize: "14px",
                                }}
                              >
                                Additional restrictions or conditions as
                                necessary.
                              </p>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        4. Copyright Infringement and Legal Enforcement
                      </h6>

                      <ul style={{ paddingLeft: "20px" }}>
                        <p
                          style={{
                            color: "#6c757d",
                            textAlign: "justify",
                            fontSize: "14px",
                          }}
                        >
                          Any unauthorised use of the Content, including
                          reproduction, distribution, and alteration, is a
                          violation of copyright law and intellectual property
                          rights.
                        </p>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Legal Action for Infringement
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            Any person or entity that copies, uses, or
                            distributes the Content without express permission
                            is subject to legal prosecution under the{" "}
                            <strong>
                              Indian Penal Code and Cybersecurity Laws of India.
                            </strong>{" "}
                            This may include penalties, fines, and other legal
                            actions.
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Reporting Infringement
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            If you become aware of any unauthorized use or
                            infringement of the Content, please contact us
                            immediately at <strong>rohinag2@gmail.com</strong>.
                            Include any relevant details such as links to
                            infringing content or screenshots, and we will take
                            appropriate action.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        5. Licence Terms and Conditions
                      </h6>

                      <ul style={{ paddingLeft: "20px" }}>
                        <p
                          style={{
                            color: "#6c757d",
                            textAlign: "justify",
                            fontSize: "14px",
                          }}
                        >
                          When permission is granted to use any Content, the
                          following terms will apply unless otherwise specified:
                        </p>

                        <li style={{ marginBottom: "15px" }}>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Non-Exclusive Licence
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            If you become aware of any unauthorized use or
                            infringement of the Content, please contact us
                            immediately at <strong>rohinag2@gmail.com</strong>.
                            Include any relevant details such as links to
                            infringing content or screenshots, and we will take
                            appropriate action.
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            Credit and Attribution
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            All authorised uses of the Content must include
                            proper credit to{" "}
                            <strong>
                              Nagesh Murthy / Nagesh Murthy Clicks
                            </strong>
                            , as specified in the licence agreement
                          </p>
                        </li>
                        <li>
                          <p
                            style={{
                              color: "#343a40",
                              fontWeight: "bold",
                              fontSize: "15px",
                            }}
                          >
                            No Transfer of Rights
                          </p>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            The rights granted under the licence are
                            non-transferable. You may not sublicense, assign, or
                            transfer your rights under the licence to any other
                            party
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        6. Modifications to This Polic
                      </h6>
                      <ul style={{ paddingLeft: "20px" }}>
                        <li>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            <strong>Nagesh Murthy </strong> reserves the right
                            to modify or update this Photography Usage Policy at
                            any time. All changes will be posted on this page,
                            and the effective date will be updated accordingly.
                            We recommend reviewing this Policy periodically to
                            stay informed of any changes.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        7. Indemnification
                      </h6>
                      <ul style={{ paddingLeft: "20px" }}>
                        <li>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            By using the Content from this Website, you agree to
                            indemnify and hold <strong>Nagesh Murthy</strong>{" "}
                            harmless from any claims, damages, liabilities, or
                            expenses arising from your unauthorised use or
                            violation of this Policy.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        8. Limitation of Liability
                      </h6>
                      <ul style={{ paddingLeft: "20px" }}>
                        <li>
                          <p
                            style={{
                              color: "#6c757d",
                              textAlign: "justify",
                              fontSize: "14px",
                            }}
                          >
                            <strong> Nagesh Murthy</strong> shall not be held
                            liable for any indirect, incidental, or
                            consequential damages arising from the use or
                            inability to use the Content, even if the
                            possibility of such damages was known or could have
                            been foreseen.
                          </p>
                        </li>
                      </ul>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        9. Contact Information
                      </h6>
                      <p
                        style={{
                          color: "#6c757d",
                          textAlign: "justify",
                          fontSize: "14px",
                        }}
                      >
                        For any questions, concerns, or requests regarding this
                        Photography Usage Policy, please contact us at:
                      </p>
                      <p
                        style={{
                          color: "#6c757d",
                          textAlign: "justify",
                          fontSize: "14px",
                        }}
                      >
                        <strong>Email:</strong> rohinag2@gmail.com
                      </p>
                      <p
                        style={{
                          color: "#6c757d",
                          textAlign: "justify",
                          fontSize: "14px",
                        }}
                      >
                        <strong>Phone:</strong> +91 9880188455
                      </p>
                      <p
                        style={{
                          color: "#6c757d",
                          textAlign: "justify",
                          fontSize: "14px",
                        }}
                      >
                        <strong>Website :</strong>{" "}
                        https://nageshamurthyclicks.com
                      </p>
                    </div>

                    <div style={{ marginTop: "20px" }}>
                      <h6
                        style={{
                          color: "#343a40",
                          marginBottom: "15px",
                          fontWeight: "bold",
                        }}
                      >
                        9. Acknowledgment
                      </h6>
                      <p
                        style={{
                          color: "#6c757d",
                          textAlign: "justify",
                          fontSize: "14px",
                        }}
                      >
                        By accessing and using the Content on this Website, you
                        acknowledge that you have read, understood, and agree to
                        the terms and conditions outlined in this Photography
                        Usage Policy.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default Policy;
